import { useEffect } from 'react';

export function useAutoUpdate() {
  useEffect(() => {
    // Only run in production browser environment
    if (import.meta.env.DEV || typeof window === 'undefined') {
      return;
    }

    let initialVersion: string | null = null;

    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          },
        });
        if (!res.ok) return;

        const data = await res.json();
        const currentVersion = data.version;

        if (!initialVersion) {
          initialVersion = currentVersion;
        } else if (currentVersion && currentVersion !== initialVersion) {
          console.info('[GAIA PULSE AutoUpdate] New deployment detected:', currentVersion);
          window.location.reload();
        }
      } catch {
        // Silently ignore network hiccup
      }
    };

    const intervalId = setInterval(checkVersion, 60000);
    return () => clearInterval(intervalId);
  }, []);
}
